import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4640de2e"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "outline" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "slider_bar" }, null, -1));
const _hoisted_3 = ["onClick"];
const _hoisted_4 = ["onClick"];
import { ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    emits: ["click"],
    setup(__props, { emit }) {
        const choiceNumber = ref(0);
        const onClick = (value) => {
            choiceNumber.value = value;
            emit('click', value);
        };
        const range = [0, 25, 50, 75, 100];
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _hoisted_2,
                _createElementVNode("div", {
                    class: "slider_bar progress",
                    style: _normalizeStyle(`width: ${choiceNumber.value}%`)
                }, null, 4),
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(range, (point) => {
                    return _withDirectives(_createElementVNode("div", {
                        key: point,
                        onClick: ($event) => (onClick(point)),
                        class: "transparent",
                        style: _normalizeStyle(`margin-left:${point - 25}%;`)
                    }, null, 12, _hoisted_3), [
                        [_vShow, point !== 0]
                    ]);
                }), 64)),
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(range, (point) => {
                    return _createElementVNode("div", {
                        key: point,
                        class: _normalizeClass(`slider_point ${choiceNumber.value >= point ? 'choice' : ''}`),
                        style: _normalizeStyle(`margin-left: ${point}%`),
                        onClick: ($event) => (onClick(point))
                    }, null, 14, _hoisted_4);
                }), 64)),
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(range, (point) => {
                    return _createElementVNode("div", {
                        key: point,
                        class: "description",
                        style: _normalizeStyle(`margin-left: ${point}%; width: 25%;`)
                    }, _toDisplayString(point) + "% ", 5);
                }), 64))
            ]));
        };
    }
});
